import React, { FC } from "react";
import { SVGProps } from "../../utils";
import { SvgWrapper } from "./SvgWrapper";

export const EmailConfirmationLogo: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg 
      width="220" 
      height="188" 
      viewBox="0 0 220 188" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M148.597 8.6068C148.597 8.6068 118.648 46.5425 70.7291 23.9141C22.8104 1.28578 -25.1086 62.5155 16.1549 99.7856C57.4184 137.056 17.039 157.536 45.0718 180.377C76.9328 206.338 104.672 153.694 129.962 165.674C185.779 192.114 227.131 181.647 217.813 151.032C201.457 97.2919 180.543 93.7958 196.516 65.8431C212.489 37.8905 177.236 -20.23 148.597 8.6068Z" 
        fill="#DEE9FF"
      />
      <path 
        d="M132.291 113.527L129.925 126.23L118.655 186.615L98.3545 182.824L111.371 113.069L111.99 109.745L132.291 113.527Z" 
        fill="#699CFF"
      />
      <path 
        d="M182.287 83.1486L175.287 120.677C175.267 120.787 175.225 120.892 175.163 120.986C175.102 121.079 175.023 121.16 174.931 121.224C174.839 121.287 174.735 121.331 174.625 121.354C174.516 121.377 174.403 121.379 174.293 121.358L75.9482 103.016L87.5234 40.9539L162.203 54.8825C175.738 57.4064 184.728 70.059 182.287 83.1486Z" 
        fill="#A2BDFF"
      />
      <path 
        d="M108.529 70.5544L101.584 107.792L49.9619 98.1637L56.907 60.9265C59.4641 47.2163 73.0934 38.257 87.3481 40.9156C101.603 43.5742 111.086 56.844 108.529 70.5544Z" 
        fill="#699CFF"
      />
      <path 
        d="M132.562 87.9615C128.757 87.252 126.248 83.5549 126.964 79.7155C127.68 75.8761 131.354 73.3315 135.158 74.0414C136.37 74.2692 137.501 74.8141 138.435 75.6207C139.369 76.4273 140.072 77.4668 140.474 78.6334L188.526 87.5957L187.228 94.5559L139.176 85.5937C138.38 86.5373 137.35 87.2535 136.188 87.6694C135.026 88.0853 133.775 88.1861 132.562 87.9615Z" 
        fill="#418DF9"
      />
      <path 
        d="M106.816 71.2388L100.049 107.519L51.4199 98.449L58.1871 62.1687C60.6784 48.8111 73.5846 40.0124 87.0131 42.517C100.442 45.0216 109.307 57.881 106.816 71.2388Z" 
        fill="#418DF9"
      />
      <path 
        d="M133.924 84.4456C135.879 84.4456 137.464 82.8606 137.464 80.9054C137.464 78.9502 135.879 77.3652 133.924 77.3652C131.969 77.3652 130.384 78.9502 130.384 80.9054C130.384 82.8606 131.969 84.4456 133.924 84.4456Z" 
        fill="white"
      />
      <path 
        d="M189.081 87.571L184.836 110.329C184.818 110.427 184.762 110.514 184.679 110.57C184.597 110.627 184.496 110.648 184.398 110.63L173.24 108.549C173.221 108.545 173.204 108.534 173.192 108.518C173.181 108.501 173.177 108.481 173.181 108.462L177.481 85.4074C177.484 85.388 177.495 85.3709 177.512 85.3598C177.528 85.3487 177.548 85.3444 177.567 85.348L189.022 87.4844C189.041 87.4881 189.058 87.4992 189.069 87.5154C189.081 87.5317 189.085 87.5516 189.081 87.571Z" 
        fill="#699CFF"
      />
      <path 
        d="M67.5128 85.4298C67.9827 88.8863 71.7756 92.9946 71.7756 92.9946C65.9961 93.4042 62.8661 90.1358 61.5193 88.1498C59.8542 88.6309 58.1428 88.9347 56.4138 89.0558C44.5487 89.8968 34.3346 82.1505 33.5969 71.7451C32.8592 61.3398 41.8787 52.23 53.7439 51.3891C65.609 50.5483 75.8224 58.2942 76.5599 68.6997C77.0397 75.468 73.3875 81.6892 67.5128 85.4298Z" 
        fill="white"
      />
      <path 
        d="M101.633 107.814C101.096 109.174 91.2703 149.69 59.4738 143.759C24.6069 137.856 49.8269 98.1519 49.8269 98.1519L101.633 107.814Z" 
        fill="#A2BDFF"
      />
      <path 
        d="M55.078 73.792C56.7073 73.792 58.0281 72.4712 58.0281 70.8419C58.0281 69.2126 56.7073 67.8918 55.078 67.8918C53.4487 67.8918 52.1279 69.2126 52.1279 70.8419C52.1279 72.4712 53.4487 73.792 55.078 73.792Z" 
        fill="#699CFF"
      />
      <path 
        d="M41.8712 72.5056C43.5103 72.5056 44.8391 71.1768 44.8391 69.5377C44.8391 67.8986 43.5103 66.5698 41.8712 66.5698C40.2321 66.5698 38.9033 67.8986 38.9033 69.5377C38.9033 71.1768 40.2321 72.5056 41.8712 72.5056Z" 
        fill="#699CFF"
      />
      <path 
        d="M68.1583 75.0492C69.7974 75.0492 71.1262 73.7205 71.1262 72.0814C71.1262 70.4423 69.7974 69.1135 68.1583 69.1135C66.5192 69.1135 65.1904 70.4423 65.1904 72.0814C65.1904 73.7205 66.5192 75.0492 68.1583 75.0492Z" 
        fill="#699CFF"
      />
      <path 
        d="M132.291 113.527L129.925 126.23L111.371 113.069L111.99 109.745L132.291 113.527Z" 
        fill="#418DF9"
      />
    </svg>
  </SvgWrapper>
);
